import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { useIntl } from "react-intl";
import { StyledDialogueBody, StyledDialogueTabs } from "./index.styled";
import TelegramBotDialogue from "./TelegramBotDialogue";
import { useQuery } from "@tanstack/react-query";
import { getTelegramBotConfig } from "@lib/api/telegramBotConfigs";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ROUTES } from "@lib/constants";

export default function TelegramBotConfigList() {
  const { messages } = useIntl();
  const { configId } = useParams();
  const [activeKey, setActiveKey] = useState<string>("1");

  const { data: dataBotConfig } = useQuery({
    queryKey: [`telegram-bot-config-${configId}`],
    queryFn: () => getTelegramBotConfig(configId),
  });

  const configName = dataBotConfig?.data?.name || "-";

  return (
    <AppsContainer
      cardBg
      cardStyle={{ height: "100%", flex: 1, padding: 10 }}
      title={messages["common.settings"] as string}
      breadcrumbProps={{
        urlParams: {
          [ROUTES.URL_PARAMS.CONFIG_ID]: configName,
        },
      }}
      cardProps={{
        borderFull: true,
      }}
    >
      <StyledDialogueBody>
        <StyledDialogueTabs
          defaultActiveKey="1"
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
          items={[
            {
              key: "1",
              label: messages["TELEGRAM.AUTHENTICATED"] as string,
              children: (
                <TelegramBotDialogue
                  requireAuth={true}
                  botConfigName={dataBotConfig?.data?.name || "-"}
                />
              ),
            },
            {
              key: "2",
              label: messages["TELEGRAM.NOT_AUTHENTICATED"] as string,
              children: (
                <TelegramBotDialogue
                  requireAuth={false}
                  botConfigName={dataBotConfig?.data?.name || "-"}
                />
              ),
            },
          ]}
        />
      </StyledDialogueBody>
    </AppsContainer>
  );
}
